import {Country} from "../../../region/types/Country";
import {RegionType} from "../../../region/types/RegionType";
import {OfferType} from "../../types/OfferType";
import {buildOfferListUrl} from "../offer_list_url/build_offer_list_url";
import {IOfferListingSeoRuleParams} from "./constants";

interface ICanonicalQueryParams {
    is_luxury?: boolean;
    priceLowerThanAverageConverted: boolean;
    offerType?: number;
    construction_end_date?: string;
    regionsSlug?: string;
}

const transformRuleParamToRegionCanonical = (params: IOfferListingSeoRuleParams): ICanonicalQueryParams => ({
    is_luxury: Boolean(params.filters.is_luxury),
    priceLowerThanAverageConverted: params.filters.price_lower_than_average === "true",
    construction_end_date: params.filters.construction_end_date,
    regionsSlug: params.regions?.[0].slug,
    offerType: params.offerType
});

export const getCustomOfferCanonical = (params: IOfferListingSeoRuleParams, offerListSubFilter?: string) => {
    const {is_luxury, priceLowerThanAverageConverted, offerType, construction_end_date, regionsSlug} = transformRuleParamToRegionCanonical(params);

    const cityDefArray = [RegionType.CITY, RegionType.TOWN];
    const isFlatsInSpecificRegions =
        params.regions?.length === 1 &&
        (priceLowerThanAverageConverted ? [...cityDefArray, RegionType.DISTRICT] : cityDefArray).includes(params.regions[0].type) &&
        params.offerType === OfferType.FLAT;
    const isHousesInSpecificRegions =
        params.regions?.length === 1 &&
        (priceLowerThanAverageConverted ? [...cityDefArray, RegionType.VOIVODESHIP] : cityDefArray).includes(params.regions[0].type) &&
        params.offerType === OfferType.HOUSE;
    const filters = {
        area_0: params.filters.area_0 ? +params.filters.area_0 : undefined,
        area_1: params.filters.area_1 ? +params.filters.area_1 : undefined,
        rooms_0: params.filters.rooms_0 ? +params.filters.rooms_0 : undefined,
        rooms_1: params.filters.rooms_1 ? +params.filters.rooms_1 : undefined,
        price_0: params.filters.price_0 ? +params.filters.price_0 : undefined,
        price_1: params.filters.price_1 ? +params.filters.price_1 : undefined
    };

    if (params.country && params.country !== Country.POLAND) {
        return buildOfferListUrl({
            type: offerType,
            region: regionsSlug,
            country: params.country
        });
    }

    if (priceLowerThanAverageConverted) {
        return buildOfferListUrl({
            ...(isFlatsInSpecificRegions || isHousesInSpecificRegions ? filters : {}),
            price_lower_than_average: priceLowerThanAverageConverted,
            type: offerType,
            region: regionsSlug
        });
    }

    if (construction_end_date === "0") {
        return buildOfferListUrl({
            ...(isFlatsInSpecificRegions || isHousesInSpecificRegions ? filters : {}),
            construction_end_date,
            type: offerType,
            region: regionsSlug
        });
    }

    return buildOfferListUrl(
        {
            region: regionsSlug,
            type: offerType,
            price_lower_than_average: priceLowerThanAverageConverted,
            is_luxury,
            construction_end_date
        },
        {subFilterSlug: offerListSubFilter}
    );
};
import {Country} from "../../../region/types/Country";
import {RegionType} from "../../../region/types/RegionType";
import {OfferType} from "../../types/OfferType";
import {buildOfferListUrl} from "../offer_list_url/build_offer_list_url";
import {IOfferListingSeoRuleParams} from "./constants";

interface ICanonicalQueryParams {
    is_luxury?: boolean;
    priceLowerThanAverageConverted: boolean;
    offerType?: number;
    construction_end_date?: string;
    regionsSlug?: string;
}

const transformRuleParamToRegionCanonical = (params: IOfferListingSeoRuleParams): ICanonicalQueryParams => ({
    is_luxury: Boolean(params.filters.is_luxury),
    priceLowerThanAverageConverted: params.filters.price_lower_than_average === "true",
    construction_end_date: params.filters.construction_end_date,
    regionsSlug: params.regions?.[0].slug,
    offerType: params.offerType
});

export const getCustomOfferCanonical = (params: IOfferListingSeoRuleParams, offerListSubFilter?: string) => {
    const {is_luxury, priceLowerThanAverageConverted, offerType, construction_end_date, regionsSlug} = transformRuleParamToRegionCanonical(params);

    const cityDefArray = [RegionType.CITY, RegionType.TOWN];
    const isFlatsInSpecificRegions =
        params.regions?.length === 1 &&
        (priceLowerThanAverageConverted ? [...cityDefArray, RegionType.DISTRICT] : cityDefArray).includes(params.regions[0].type) &&
        params.offerType === OfferType.FLAT;
    const isHousesInSpecificRegions =
        params.regions?.length === 1 &&
        (priceLowerThanAverageConverted ? [...cityDefArray, RegionType.VOIVODESHIP] : cityDefArray).includes(params.regions[0].type) &&
        params.offerType === OfferType.HOUSE;
    const filters = {
        area_0: params.filters.area_0 ? +params.filters.area_0 : undefined,
        area_1: params.filters.area_1 ? +params.filters.area_1 : undefined,
        rooms_0: params.filters.rooms_0 ? +params.filters.rooms_0 : undefined,
        rooms_1: params.filters.rooms_1 ? +params.filters.rooms_1 : undefined,
        price_0: params.filters.price_0 ? +params.filters.price_0 : undefined,
        price_1: params.filters.price_1 ? +params.filters.price_1 : undefined
    };

    if (params.country && params.country !== Country.POLAND) {
        return buildOfferListUrl({
            type: offerType,
            region: regionsSlug,
            country: params.country
        });
    }

    if (priceLowerThanAverageConverted) {
        return buildOfferListUrl({
            ...(isFlatsInSpecificRegions || isHousesInSpecificRegions ? filters : {}),
            price_lower_than_average: priceLowerThanAverageConverted,
            type: offerType,
            region: regionsSlug
        });
    }

    if (construction_end_date === "0") {
        return buildOfferListUrl({
            ...(isFlatsInSpecificRegions || isHousesInSpecificRegions ? filters : {}),
            construction_end_date,
            type: offerType,
            region: regionsSlug
        });
    }

    return buildOfferListUrl(
        {
            region: regionsSlug,
            type: offerType,
            price_lower_than_average: priceLowerThanAverageConverted,
            is_luxury,
            construction_end_date
        },
        {subFilterSlug: offerListSubFilter}
    );
};
